import MarkdownRender from './markdown2'
import '../App.css'
import { Card, CardContent, Typography, withStyles } from '@material-ui/core'


const CardContentEdit = withStyles({
  root:{
    padding:'10px 10px 0px 10px',
    "&:last-child":{  
      paddingBottom:'10px'
    }
  },

})(CardContent)

const View = props => {
  
      return (
        <Card style={{
          background:'rgba(255,255,255,0.1)',
          color: props.isDark ? 'white' : 'black',
          marginTop:25, 
          border: !props.isDark ? 'solid 1px black' : null
        }}>
          <CardContentEdit> 
            <Typography variant="subtitle1" component="p" style={{background: props.isDark ? 'rgba(255,255,255,0.1)' : 'rgba(000,000,000,0.1)' , borderRadius:5, padding: '1px 10px 1px 10px', wordWrap: 'break-word'}}>
              <MarkdownRender>{props.data.question}</MarkdownRender>
            </Typography>
              <Typography style={{marginTop:5, marginBottom:5}} variant="substitle2" component="p"><b>Odpowiedzi</b></Typography>
              {props.data.answers.map(x => {
                return (
                  <div style={{
                    background: x.correct ? props.isDark ? 'green': '#2BE073' : null,
                    borderRadius:5,
                    padding: '1px 10px 1px 10px',
                    wordWrap: 'break-word',
                    marginTop:5
                  }}>
                      <MarkdownRender>{x.text}</MarkdownRender>
                  </div>
                )
              })}
          </CardContentEdit>
        </Card>
      );
}

export default View